import { MESES, ACCIONES_SEMANAL, initSemanal } from '../constants/formConfig';
import { Inp, Sel, RG, Btn } from './ui/FormControls';

export const SemanalForm = ({ semanal, setSemanal, guardar }) => (
  <div className="bg-white rounded-xl shadow p-4 space-y-4">
    <h2 className="font-bold text-gray-800 border-b pb-2">📆 Mantenimiento Almacén Semanal</h2>
    <div className="grid grid-cols-2 gap-3">
      <Inp label="Responsable *" value={semanal.responsable} onChange={v => setSemanal(s => ({ ...s, responsable: v }))} placeholder="Nombre" />
      <Inp label="Año" value={semanal.anio} onChange={v => setSemanal(s => ({ ...s, anio: v }))} placeholder="2025" />
      <Sel label="Mes" value={semanal.mes} onChange={v => setSemanal(s => ({ ...s, mes: v }))} options={MESES} />
      <Sel label="Semana" value={semanal.semana} onChange={v => setSemanal(s => ({ ...s, semana: v }))} options={["1", "2", "3", "4"]} />
    </div>
    <div className="border rounded-lg overflow-hidden">
      <div className="bg-yellow-100 px-3 py-2"><p className="text-xs font-bold text-yellow-800 uppercase">📋 {semanal.mes} — Semana {semanal.semana}</p></div>
      <div className="divide-y">{ACCIONES_SEMANAL.map(k => (
        <div key={k} className="px-3 py-3 space-y-2">
          <div className="flex items-start justify-between gap-2">
            <span className="text-sm font-semibold text-gray-800 flex-1">{k}</span>
            <RG value={semanal.rows[k]?.value || ""} onChange={v => setSemanal(s => ({ ...s, rows: { ...s.rows, [k]: { ...s.rows[k], value: v } } }))} opts={["✓ OK", "✗ NO"]} />
          </div>
          <input className="w-full border rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder="Observaciones..." value={semanal.rows[k]?.obs || ""} onChange={e => setSemanal(s => ({ ...s, rows: { ...s.rows, [k]: { ...s.rows[k], obs: e.target.value } } }))} />
        </div>
      ))}</div>
    </div>
    <Btn onClick={() => { guardar(`APPCC Semanal — ${semanal.mes} S${semanal.semana}`, semanal); setSemanal(initSemanal()); }} disabled={!semanal.responsable}>Enviar para validación →</Btn>
  </div>
);
